import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import { RestApplianceModel } from '@shared/interfaces/appliance.interface';

@Injectable({
  providedIn: 'root',
})
export class AppliancesService {
  constructor(private restApiService: RestapiService) {}

  getAppliance(applianceId: number): Observable<RestApplianceModel> {
    return this.restApiService.getData<RestApplianceModel>(`Appliances/${applianceId}`);
  }
}
